// extracted by mini-css-extract-plugin
var _1 = "ProspectBanner_banner__JDAbS";
var _2 = "ProspectBanner_navLink__OcB81";
export { _1 as "banner", _2 as "navLink" }
